module.exports = __webpack_public_path__ + "static/media/business_person.18fdfe5e.svg";